var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyGray600(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33325 14H3.33325C2.80282 14 2.29411 13.7893 1.91904 13.4142C1.54397 13.0391 1.33325 12.5304 1.33325 12V3C1.33325 2.46957 1.54397 1.96086 1.91904 1.58579C2.29411 1.21071 2.80282 1 3.33325 1H12.3333C12.8637 1 13.3724 1.21071 13.7475 1.58579C14.1225 1.96086 14.3333 2.46957 14.3333 3V4M10.3333 8H19.3333C20.4378 8 21.3333 8.89543 21.3333 10V19C21.3333 20.1046 20.4378 21 19.3333 21H10.3333C9.22868 21 8.33325 20.1046 8.33325 19V10C8.33325 8.89543 9.22868 8 10.3333 8Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyGray600);
export default __webpack_public_path__ + "static/media/copy-gray600.33347dd87aae1860a7e03cc88c2162b8.svg";
export { ForwardRef as ReactComponent };